import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

// 查询任务列表
export type CompWelfareTaskRes = {
  taskId: string; // 任务ID
  taskName: string; // 任务名称
  taskStatus: string; // 任务状态-1 待完成，2 已完成 3 任务条件不满足
  taskType: string; //任务类型-1 分享，2 浏览，3 邀新，4 学生认证，5 通行证绑定资金账号 ，7 签到，8 报名
  taskLimit: number; //单客户周期任务/多次任务，次数限制，例如最多可邀X人
  taskParam: string; // 任务参数
  rewards: number; //次数奖励
  iosUrl: string; //IOS跳转链接
  androidUrl: string; // 安卓跳转链接
  h5Url: string; //H5跳转链接
  taskData: string; // 任务临时数据
  remark: string; // 任务说明
  taskIcon: string; // 任务logo
  shareTitle: string; // 分享标题
  shareIcon: string; // 分享标题
  shareDesc: string; // 分享描述
  shareUrl: string; // 分享跳转链接
  taskFreq: number; // 任务频率 1 单次任务  2 多次任务  3 周期任务
  taskFinishTimes: number; // 任务完成次数
  extParams?: string;
  url?: string;
};
interface dataRes {
  normal: CompWelfareTaskRes[];
  surprise?: CompWelfareTaskRes[];

  finished?: CompWelfareTaskRes[];
}
interface getTaskListResponse {
  data: dataRes;
  code: number;
}
export async function queryTaskList() {
  const url = config.zqhpLink + '/activity/competition-welfare/getTaskList';
  return zqhdApi.fetch<getTaskListResponse>(url);
}
